import Toggle from "@vueform/toggle";
import { reactive } from "vue";
import { Options, Vue } from "vue-class-component";
import { useToast } from "vue-toastification";

import TableLite from "@/components/table/TableLiteTs.vue";
import { Credential, CredentialType } from "@/domain/credentials.model";
import router from "@/router";
import { CredentialService } from "@/services/credentials.service";

@Options({
  components: {
    TableLite,
    Toggle,
  },
})
export default class Credentials extends Vue {
  public files: Credential;
  public table = TABLE;
  private toast = useToast();
  public showInsertForm = false;
  public showInsertResponse = false;
  public showModalChangeStatus = false;
  public dataForm: Credential = {
    accessKey: "",
    description: "",
    enabled: true,
    bucket: "",
    accountCode: "",
  };

  public errors = {};
  public errorMessage = "";
  public hasError = false;

  public mounted(): void {
    if (this.$store.getters["auth/type"] !== CredentialType.MASTER) {
      router.replace("/");
    }

    this.getCredentials();
  }

  public async getCredentials(): Promise<void> {
    try {
      const response = await CredentialService.getCredentials();
      this.table.rows = response;
    } catch (error) {
      const message = error.response?.data?.message || "Erro ao listar registros.";

      this.toast.error(message, { timeout: false });
    }
  }

  public newCredential(): void {
    this.dataForm = {
      accessKey: "",
      description: "",
      enabled: true,
      bucket: "",
      accountCode: "",
    };
    this.showInsertForm = true;
  }

  public closeModal() {
    this.showInsertForm = false;
    this.showInsertResponse = false;
  }

  public closeModalChangeStatus() {
    this.showModalChangeStatus = false;
    // const item = this.table.rows.find(i => i.accessKey === this.dataForm.accessKey);
    // item["enabled"] = !this.dataForm.enabled;
    this.table.rows.forEach(i => {
      if (i.accessKey === this.dataForm.accessKey) {
        i.enabled = !this.dataForm.enabled;
      }
    });
  }

  public validation() {
    this.errorMessage = "";
    this.errors = {};
    this.hasError = false;

    if (this.dataForm.accountCode.length < 5) {
      this.errors["accountCode"] = "Este campo não pode ter menos de 5 caracteres.";
      this.hasError = true;
    }

    if (this.dataForm.accountCode.length > 20) {
      this.errors["accountCode"] = "Este campo não pode ter mais de 20 caracteres.";
      this.hasError = true;
    }

    if (!this.dataForm.accountCode?.trim()) {
      this.errors["accountCode"] = "Este campo deve ser preenchido";
      this.hasError = true;
    }

    if (this.dataForm.accessKey.length < 10) {
      this.errors["accessKey"] = "Este campo não pode ter menos de 10 caracteres.";
      this.hasError = true;
    }

    if (this.dataForm.accessKey.length > 100) {
      this.errors["accessKey"] = "Este campo não pode ter mais de 100 caracteres.";
      this.hasError = true;
    }

    if (!this.dataForm.accessKey?.trim()) {
      this.errors["accessKey"] = "Este campo deve ser preenchido";
      this.hasError = true;
    }

    if (this.dataForm.description.length > 300) {
      this.errors["description"] = "Este campo não pode ter mais de 300 caracteres.";
      this.hasError = true;
    }

    if (!this.dataForm.description?.trim()) {
      this.errors["description"] = "Este campo deve ser preenchido";
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      CredentialService.insert(this.dataForm)
        .then(res => {
          this.dataForm = res;
          this.showInsertForm = false;
          this.showInsertResponse = true;

          this.getCredentials();
        })
        .catch(error => {
          this.errorMessage =
            error.response?.data?.message === "accessKey already exists"
              ? "Login informado já utilizado."
              : "Ocorreu um erro ao gravar o registro";
        });
    }
  }

  public showChangeStatus(accessKey: string, enabled: boolean): void {
    this.showModalChangeStatus = true;
    this.dataForm.accessKey = accessKey;
    this.dataForm.enabled = enabled;
  }

  public changeStatus(): void {
    CredentialService.changeStatus(this.dataForm.accessKey, this.dataForm.enabled)
      .then(() => {
        this.showModalChangeStatus = false;
      })
      .catch(() => {
        this.errorMessage = "Ocorreu um erro ao gravar o registro";
      });
  }
}

export const TABLE = reactive({
  isLoading: false,
  columns: [
    { field: "accountCode", label: "IDENTIFICADOR DA CONTA", sortable: true, isKey: true },
    { field: "accessKey", label: "LOGIN" },
    { field: "description", label: "DESCRIÇÃO" },
    { field: "actions" },
  ],
  rows: [] as Credential[],
  sortable: {
    order: "id",
    sort: "desc",
  },
});
